import { useCallback } from "react";
import { toast } from "sonner";
import { api, errMsg } from "./api";
import { useAuth } from "./auth";
import { analytics } from "./analytics";

export const PREF_DEFAULTS = {
  notify: "mentions", keywords: [], sound: true, title_badge: true, desktop: true, inline_previews: true, large_emoji: true, thread_replies: true, push_huddles: true,
  dnd: { enabled: false, start: "22:00", end: "08:00" },
  sounds: { volume: 70, huddles: true, sent: false, notification: "knock" },
};

export const mergePrefs = (p) => ({ ...PREF_DEFAULTS, ...(p || {}), dnd: { ...PREF_DEFAULTS.dnd, ...(p?.dnd || {}) }, sounds: { ...PREF_DEFAULTS.sounds, ...(p?.sounds || {}) } });

export const usePrefs = () => {
  const { user, setUser } = useAuth();
  const prefs = mergePrefs(user?.prefs);
  const update = useCallback(async (patch) => {
    setUser((u) => (u ? { ...u, prefs: mergePrefs({ ...u.prefs, ...patch }) } : u));
    analytics.track("preference_changed", { category: "preferences", label: Object.keys(patch).join(","), metadata: patch });
    try {
      const { data } = await api.patch("/users/me/prefs", patch);
      setUser((u) => (u ? { ...u, prefs: data } : u));
    } catch (e) {
      toast.error(errMsg(e, "Couldn't save preference"));
    }
  }, [setUser]);
  return [prefs, update];
};

export const inDnd = (dnd, d = new Date()) => {
  if (!dnd?.enabled) return false;
  const toMin = (s) => { const [h, m] = String(s).split(":").map(Number); return h * 60 + (m || 0); };
  const cur = d.getHours() * 60 + d.getMinutes();
  const start = toMin(dnd.start);
  const end = toMin(dnd.end);
  return start <= end ? cur >= start && cur < end : cur >= start || cur < end;
};
